import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useUpdateAccountGroups } from "@/features/accounts/account-group/hooks/use-update-account-groups";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";


interface Props {
  onTapCloseModal: () => void;
  onTapCompleteModal: () => void;
}

export const MoveAccountGroupModal = ({ onTapCloseModal, onTapCompleteModal }: Props) => {
  const {
    accountGroups,
    selectedAccount,
  } = useAccountGroupsContext();
  const {
    setOpenMyDataModal,
  } = useModalContext();

  const {
    updateAccountGroups,
  } = useUpdateAccountGroups({ onTapCompleteModal });

  const onClickAccountGroup = (accountGroupId: string) => {
    if (!selectedAccount) return;
    const moveAccountsList = [
      {
        mlink_account_id: selectedAccount.mlinkAccountId,
        mlink_id: selectedAccount.mlinkId,
        passbook_type: selectedAccount.passbookType,
      }
    ]
    updateAccountGroups(
      accountGroupId,
      undefined,
      undefined,
      moveAccountsList,
    );
    setOpenMyDataModal(undefined);
  };

  return (
    <BasePageModal
      handleClose={onTapCloseModal}
      title="グループを移動する"
      className="md-group-edit"
    >
      <h2>
        どのグループへ移動させますか？
      </h2>
      <ul>
        {accountGroups.map((item, index) => (
          (item.accountGroupId !== selectedAccount?.accountGroupId && !(item.shared === 1 && item.isOwner === 0)) && (
          <li key={index}>
            <BaseRoundButton
            className="btn-group"
              buttonText={item.accountGroupsName}
              onClick={() => {
                onClickAccountGroup(item.accountGroupId);
              }}
            />
          </li>
          ))
        )}
      </ul>
    </BasePageModal>
  );
};
